import env from '~/libs/env'
import { defineStore } from 'pinia'
import { ref } from 'vue'
// import { useBorrowerStore } from '~/store/borrower'

export const useContactGuestStore = defineStore('contactGuest', () =>{
  const nuxtApp = useNuxtApp()
  const { $axios, $lendioCookies } = nuxtApp

  /*
  ███████ ████████  █████  ████████ ███████
  ██         ██    ██   ██    ██    ██
  ███████    ██    ███████    ██    █████
       ██    ██    ██   ██    ██    ██
  ███████    ██    ██   ██    ██    ███████
  STATE
  */
  const businessName = ref($lendioCookies.get('guestBusinessName') || 'your business')
  const primaryOwnerName = ref($lendioCookies.get('guestPrimaryOwnerName') || 'the original applicant')
  const secureLink = ref($lendioCookies.get('guestSecureLink') || '')

  const contactFirst = ref('')
  const contactLast = ref('')
  const modules = ref([])
  const token = ref('')

  /*
  ██████   ███████ ████████ ████████ ███████ ██████  ███████
  ██       ██         ██       ██    ██      ██   ██ ██
  ██   ███ █████      ██       ██    █████   ██████  ███████
  ██    ██ ██         ██       ██    ██      ██   ██      ██
  ██████   ███████    ██       ██    ███████ ██   ██ ███████
  GETTERS
  */
  const _parseLink = (_secureLink) => {
    try {
      JSON.parse(atob(_secureLink))
    } catch (e) {
      return false
    }
    return true
  }

  const getIsBadSecureLink = computed(() => {
    return !secureLink.value || secureLink.value === '' || _parseLink(secureLink.value) === false
  })

  /*
   █████   ██████ ████████ ██  ██████  ███    ██ ███████
  ██   ██ ██         ██    ██ ██    ██ ████   ██ ██
  ███████ ██         ██    ██ ██    ██ ██ ██  ██ ███████
  ██   ██ ██         ██    ██ ██    ██ ██  ██ ██      ██
  ██   ██  ██████    ██    ██  ██████  ██   ████ ███████
  ACTIONS
  ! - - Actions calling other actions in the same store must use `this.actionName(...)`
  ! - - If we do not use `this.actionName` it will not be properly mockable in tests.
  ! - - Computeds and refs will work fine, and should be called directly though.
  */

  async function submitMfaCode ( mfaCode ) {
    if (!secureLink.value || secureLink.value === '') {
      return { errored: true, error: 'Secure link is not set.' }
    }

    return $axios.post(`${env('apiUrl')}/contact/guest/additional-owners`,
        {
          accessCode: mfaCode, secureLink: secureLink.value
        }
      )
      .then(response => {
        const data = response?.data?.data

        contactFirst.value = data?.contactFirst || ''
        contactLast.value = data?.contactLast || ''
        businessName.value = data?.businessName || 'your business'
        primaryOwnerName.value = data?.primaryOwnerName || 'the original applicant'
        modules.value = data?.modules || []
        token.value = data?.token || ''

        return response?.data
      })
      .catch(error => {
        console.log(error)
        return { errored: true, error }
      })
  }

  async function updatePersonalInfo (answers) {
    if (!token.value || token.value === '') {
      return { errored: true, error: 'Token is not set.' }
    }

    return $axios.put(`${env('apiUrl')}/contact/guest/additional-owners`, {
      ...answers,
    }, { headers: { 'Authorization': `lendio-jwt ${token.value}` } })
      .then(response => {
        return response?.data
      })
      .catch(error => {
        console.log(error)
        return { errored: true, error }
      })
  }

  function resetValues() {
    businessName.value = 'your business'
    primaryOwnerName.value = 'the original applicant'
    contactFirst.value = ''
    contactLast.value = ''
    modules.value = []
    token.value = ''
  }

  function initializeValues ({ _businessName, _primaryOwnerName, _secureLink }) {
    if (_secureLink) {
      this.resetValues()

      $lendioCookies.set('guestSecureLink', _secureLink, { expires: 1 })
      secureLink.value = _secureLink
    }

    if (_businessName) {
      $lendioCookies.set('guestBusinessName', _businessName, { expires: 1 })
      businessName.value = _businessName
    }

    if (_primaryOwnerName) {
      $lendioCookies.set('guestPrimaryOwnerName', _primaryOwnerName, { expires: 1 })
      primaryOwnerName.value = _primaryOwnerName
    }
  }

  return {
    // State
    businessName,
    contactFirst,
    contactLast,
    modules,
    primaryOwnerName,
    token,
    secureLink,

    // Getters
    getIsBadSecureLink,

    // Actions
    initializeValues,
    resetValues,
    submitMfaCode,
    updatePersonalInfo,
  }
})
